import { useDispatch, useSelector } from 'react-redux'
import React from 'react'

import {
  getScreenshots,
  setSelectedScreenshotId
} from '~/actions/screenshots'
import {
  getFetchingInProgress,
  selectScreenshots,
  getSelectedScreenshotId,
  selectHasMorePages
} from '~/selectors/screenshots'
import { getDialogProps, getViewedSessionId } from '~/selectors/ui'

import Slideshow from '~/components/dialogs/slideshow'
import Screenshot from '../screenshot'
import EmphasisedSlide from './emphasised-slide'
import SlideshowActions from './actions'
import { isSalesforceIntegration } from '~/selectors/app'

const ScreenshotsSlideshowDialog = () => {
  const dispatch = useDispatch()
  const dialogProps = useSelector(getDialogProps)
  const sessionId = dialogProps.id || useSelector(getViewedSessionId)
  const fetchingInProgress = useSelector(getFetchingInProgress(sessionId))
  const screenshots = useSelector(selectScreenshots(sessionId))
  const firstScreenshotId = Object.values(screenshots)[0].objectId
  const selectedScreenshotId = useSelector(getSelectedScreenshotId(sessionId)) || firstScreenshotId
  const hasMoreScreenshots = useSelector(selectHasMorePages(sessionId))
  const canClose = !useSelector(isSalesforceIntegration)

  const fetchMoreScreenshots = () => {
    dispatch(getScreenshots(sessionId))
  }

  const selectScreenshot = screenshot => {
    dispatch(setSelectedScreenshotId({ sessionId, screenshotId: screenshot.objectId }))
  }

  return (
    <Slideshow
      canClose={canClose}
      fetchingInProgress={fetchingInProgress}
      hasMore={hasMoreScreenshots}
      onFetchMore={fetchMoreScreenshots}
      onSelect={selectScreenshot}
      selectedSlide={screenshots[selectedScreenshotId]}
      SelectedSlideComponent={EmphasisedSlide}
      SlideActions={SlideshowActions}
      SlideComponent={Screenshot}
      slideNameMapping='screenshot'
      slideProps={{
        sessionId
      }}
      slides={Object.values(screenshots)}
    />
  )
}

export default ScreenshotsSlideshowDialog
